<template>
  <v-row>
    <v-col cols="12" md="4">
      <v-skeleton-loader
        type="card-avatar, article, actions"
      ></v-skeleton-loader>
    </v-col>

    <v-col cols="12" md="4">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>

      <v-skeleton-loader
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </v-col>

    <v-col cols="12" md="4">
      <v-skeleton-loader
        type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        type="list-item-avatar-three-line, image, article"
      ></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'StrappGroupsSkeleton',

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
